import { useQueryClient } from '@tanstack/react-query';
import { authApi } from 'auth/auth.api';
import { useAuth } from 'auth/AuthProvider';
import { invalidateAfterProfileOrLocale } from 'core/api/invalidation';
import { humanizeApiError } from 'core/errors/mapFieldErrors';
import { useI18n } from 'core/i18n/I18nProvider';
import { useToast } from 'shared/components/Toast';

export function usePersistPreferredLocale() {
  const { t, locale, setLocale } = useI18n();
  const { isAuthenticated, applyUser } = useAuth();
  const toast = useToast();
  const queryClient = useQueryClient();

  return async function persistLocale(nextLocale) {
    if (!isAuthenticated) {
      return;
    }
    const previous = locale;
    try {
      const updated = await authApi.updateProfile({ preferred_locale: nextLocale });
      applyUser(updated);
      await invalidateAfterProfileOrLocale(queryClient);
    } catch (err) {
      setLocale(previous);
      toast.error(humanizeApiError(err, t));
    }
  };
}
